import { z } from 'zod/v4';
import { toLocalISOString } from '../utils/date';

// Helper to parse date string in DD/MM/YYYY format and set to 00:00:00
function parseDateStringToMidnight(dateStr: string): Date {
  const [day, month, year] = dateStr.split('/').map(Number);

    if (!day || !month || !year) {
        throw new Error('Invalid date format. Expected DD/MM/YYYY');
    }
  return new Date(year, month - 1, day, 0, 0, 0, 0); // Set to 00:00:00
}

// Helper to parse time string in HH:MM format and set to today's date
function parseTimeStringToToday(timeStr: string): Date {
    const [hours, minutes] = timeStr.split(':').map(Number);
    const date = new Date();
    if (!hours || !minutes || isNaN(hours) || isNaN(minutes)) {
        throw new Error('Invalid time format. Expected HH:MM');
    }
    date.setHours(hours, minutes, 0, 0);
    return date;
}

export const LSDateSchema = z.union([
    z.coerce.date(),
    z.date(),
    z.string()
]).transform((val) => {
    if (typeof val === 'string') {
        if (val.includes('T')) return val;
        
        // Handle DD/MM/YYYY format - default to 00:00:00
        if (val.includes('/')) {
            const date = parseDateStringToMidnight(val);
            return toLocalISOString(date);
        }

        return val;
    }

    // Set date objects to 00:00:00 of that day
    const date = new Date(val);
    date.setHours(0, 0, 0, 0);
    return toLocalISOString(date);
})

export const LSDateTimeSchema = z.union([
    z.coerce.date(),
    z.date(),
    z.string()
]).transform((val) => {
    if (typeof val === 'string') {
        if (val.includes('T')) return val;
        
        // Handle HH:MM format
        if (val.includes(':')) {
            const date = parseTimeStringToToday(val);
            return toLocalISOString(date);
        }

        return val;
    }

    return toLocalISOString(val);
})